<template>
    <div class="share-here">
        <hr v-if="hr == 'above'"/>
        <div class="row">
            <div class="col-sm-12">
                <h2>Every Fanwalk Brick has a story. Share yours here!</h2>
            </div>
            <div class="col-sm-3">
                <form action="" class="info-form">
                    <div class="row">
                        <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.first_name') }">
                            <input type="text" class="form-control" placeholder="First Name"
                                v-model="story.first_name"
                                data-vv-name="story.first_name"
                                v-validate="'required'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.last_name') }">
                            <input type="text" class="form-control" placeholder="Last Name"
                               v-model="story.last_name"
                               data-vv-name="story.last_name"
                               v-validate="'required'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.phone') }">
                            <input type="tel"class="form-control" placeholder="Phone Number"
                                v-model="story.phone"
                                data-vv-name="story.phone"
                                v-validate="'required|digits:10'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" v-bind:class="{'has-error': errors.has('story.email') }">
                            <input type="email" class="form-control" placeholder="Email Address"
                                v-model="story.email"
                                data-vv-name="story.email"
                                v-validate="'required|email'"
                            />
                        </div>
                    </div>
                    <input type="hidden" name="order_id" v-model="order"/>
                </form>
            </div>
            <div class="col-sm-9">
                <form action="" class="info-form">
                    <textarea class="form-control" v-model="story.description"
                        placeholder="Enter your story here. Share with us the meaning behind your inscription, why you bought your brick, or what this program means to you. Your stories and photos can become a part of history that will never be forgotten!"
                    ></textarea>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <em class="text-small">
                    By submitting your story, you agree to authorize D.C. United and their affiliates
                    to use your story for marketing purposes, including, but not limited to, social media, television,
                    radio and print marketing. Further, your submission of this form indicates your approval
                    for D.C. United to contact you for additional information.
                </em>
            </div>
        </div>
        <div class="row" v-if="isStorySubmitted">
            <div class="col-sm-12">
                <div class="text-danger">
                    <h4><strong>Thank you for sharing your story!</strong></h4></div>
            </div>
        </div>
        <div class="row" v-if="errors.has('photo')">
            <div class="col-sm-12">
                <span class="text-danger">{{ errors.first('photo') }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="text-right">
                    <input id="file-upload" type="file" accept="image/*"
                        name="photo"
                        v-on:change="onFileChange"
                        v-validate="'image|size:2048'"
                    />
                    <label for="file-upload" class="btn btn-outline-danger pointer">Photo Upload</label>
                    &nbsp;
                    <a class="btn btn-danger" v-on:click="onSubmit">Submit Story</a>
                </div>
            </div>
        </div>
        <hr v-if="hr !== 'above'"/>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'share-story',
        props: {
            hr: {
                required: true,
                type: String,
                default: 'above'
            },
            order: {
                required: false,
                type: String,
                default: ''
            }
        },
        data: function () {
            return this.getDefaultData();
        },
        methods: {
            getDefaultStory: function () {
                return {
                    form: new FormData(),
                    story: {
                        /**/
                        first_name: '',
                        last_name: '',
                        phone: '',
                        email: '',
                        description: ''
                        /**/
                        // DEBUG
                        /** /
                        first_name: 'Norma',
                        last_name: 'Baker',
                        phone: '5551234567',
                        email: 'njb@bollywood.com',
                        description: 'lorem ipsum dolor sit amet'
                        /**/
                    }
                }
            },
            getDefaultData: function () {
                return {
                    isStorySubmitted: false,
                    ...this.getDefaultStory()
                }
            },
            reset: function () {
                Object.assign(this.$data, this.getDefaultStory());
            },
            onFileChange: function (e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                this.form.set('image', files[0], files[0].name);
            },
            onSubmit: function () {
                this.$validator.validateAll().then(() => {
                    /* global FRS_CAMPAIGN, FRS_API_HOST */
                    var endpoint = window.location.protocol + FRS_API_HOST + '/api/story/upload';
                    this.form.set('campaign', FRS_CAMPAIGN);
                    Object.keys(this.story).map((key) => {
                        this.form.set(key, this.story[key]);
                    });
                    if (+this.order > 0) {
                        this.form.set('order_id', this.order);
                    }
                    this.$http.post(endpoint, this.form, {
                        headers : {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(function (response) {
                        var data = response.body || {};
                        var success = 'success' in data ? data.success : false;
                        if (success) {
                            this.isStorySubmitted = true;
                        } else {
                            var errors = 'errors' in data ? data.errors : {};
                            if ('image' in errors) {
                                console.log('error message:', errors.image);
                            }
                        }
                        this.reset();
                    }, function (error) {
                        console.log('Network error: ', error);
                    });
                }).catch(function (err) {
                    console.log('NEED to correct some errors first!' /* , err */);
                });
                return false;
            }
        }
    }
</script>

<style scoped>
    input[type="file"] {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// ShareStory.vue?29b08422